import { useState, useRef, useEffect } from 'react';
import { Autocomplete, TextField, Paper, ListItem, Box, Typography } from '@mui/material';
import debounce from 'lodash/debounce';

const ProductCodeAutocomplete = ({ value, onChange, fetchSuggestions, label, error, helperText, isEditMode }) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const debouncedFetch = useRef(
        debounce(async (keyword) => {
            if (!keyword) {
                setOptions([]);
                return;
            }
            setLoading(true);
            const res = await fetchSuggestions(keyword);
            setOptions(res || []);
            setLoading(false);
        }, 300)
    ).current;

    useEffect(() => {
        return () => {
            debouncedFetch.cancel();
        };
    }, []);

    return (
        <Autocomplete
            freeSolo
            disabled={!isEditMode}
            options={options}
            loading={loading}
            filterOptions={(x) => x} // API結果そのまま
            getOptionLabel={(option) => typeof option === 'string' ? option : option.product_code}
            inputValue={value}
            onInputChange={(_, newValue) => {
                onChange(newValue);
                debouncedFetch(newValue);
            }}
            onChange={(_, option) => {
                if (!option) return;
                onChange(option.product_code);
            }}
            renderInput={(params) => (
                <TextField
                    label={label}
                    {...params}
                    disabled={!isEditMode}
                    size="small"
                    error={!!error}
                    helperText={helperText}
                    inputProps={{
                        ...params.inputProps,
                        maxLength: 100,
                    }}
                />
            )}
            PaperComponent={(props) => <Paper {...props} sx={{ width: 500 }} />}
            renderOption={(props, item) => (
                <ListItem {...props} key={item.product_code}>
                    <Box>
                        <Typography>{item.product_code} - {item.product_name}</Typography>
                    </Box>
                </ListItem>
            )}
        />
    );
};

export default ProductCodeAutocomplete;